import './InputLabel-0ed9ee81.css';

var classes = {"Label":"prc-components-Label-bE-kK","RequiredText":"prc-components-RequiredText-ztJvt"};

export { classes as default };
